<template>
  <div class="iphone-screen">
    <div class="iphone">
      <div class="screen">
        <div class="scroll-content">
          <div class="iphone-content">
            <div class="time">
              15:21
            </div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpIphone',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.iphone-screen {
  margin-left: 60px;
  .iphone {
    width: 200px;
    height: 400px;
    background: url('../../assets/img/iphone.png') no-repeat;
    background-size: contain;

    .screen {
      width: 100%;
      height: 100%;
      padding: 50px 20px;
      box-sizing: border-box;

      .scroll-content {
        width: 100%;
        height: 100%;
        overflow: auto;
        padding-bottom: 10px;
        .iphone-content {
          width: 100%;
          height: auto;

          .time {
            font-size: 12px;
            color: #999;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
